module.exports = __webpack_public_path__ + "static/media/EnrichBadOptimized.eb92b007.jp2";